<h3 class="flex tw:flex">
  {{ 'templates.tasks' | translate }}
  @if (roleS() === 'super-admin') {
    <ion-button color="light"
      slot="end"
      (click)="onTicketTemplate()">
      {{ 'item.add' | translate }}
    </ion-button>
  }
</h3>
<div>
  @for (template of unifiedTemplates$ | async; track template.guid) {
    <ion-item lines="none">
      {{ template.name }}
      <ion-button slot="end"
        (click)="onTicketTemplate(template)">
        <ion-icon slot="icon-only"
          name="create-outline"></ion-icon>
      </ion-button>
    </ion-item>
  } @empty {
    <app-no-results></app-no-results>
  }
</div>
@if (roleS() === 'super-admin') {
  <h3 class="flex tw:flex">
    {{ 'templates.projects' | translate }}
    <ion-button color="light"
      (click)="onNewProjectTemplate()">
      {{ 'item.add' | translate }}
    </ion-button>
  </h3>
  <div>
    @for (template of projectTemplates$ | async; track template.guid) {
      <ion-item lines="none">
        {{ template.name }}
      </ion-item>
    } @empty {
      <app-no-results></app-no-results>
    }
  </div>
}
